module.exports = __webpack_public_path__ + "img/20180815_150609_099.2053c259.jpg";